var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("form-item", {
        attrs: { label: "Bank Name" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function() {
              return [
                _c("Input", {
                  attrs: {
                    placeholder: "Bank Name",
                    error: _vm.$v.bank.$dirty && !_vm.$v.bank.required
                  },
                  model: {
                    value: _vm.bank,
                    callback: function($$v) {
                      _vm.bank = $$v
                    },
                    expression: "bank"
                  }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "flex flex-col pt-2" },
                  [
                    _vm.$v.bank.$dirty && !_vm.$v.bank.required
                      ? _c("text-error", {
                          attrs: { text: "Bank Name must be filled." }
                        })
                      : _vm._e()
                  ],
                  1
                )
              ]
            },
            proxy: true
          }
        ])
      }),
      _vm._v(" "),
      _c("form-item", {
        attrs: { label: "Account Name" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function() {
              return [
                _c("Input", {
                  attrs: {
                    placeholder: "Account Name",
                    error:
                      _vm.$v.account_name.$dirty &&
                      !_vm.$v.account_name.required
                  },
                  model: {
                    value: _vm.account_name,
                    callback: function($$v) {
                      _vm.account_name = $$v
                    },
                    expression: "account_name"
                  }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "flex flex-col pt-2" },
                  [
                    _vm.$v.account_name.$dirty && !_vm.$v.account_name.required
                      ? _c("text-error", {
                          attrs: { text: "Account Name must be filled." }
                        })
                      : _vm._e()
                  ],
                  1
                )
              ]
            },
            proxy: true
          }
        ])
      }),
      _vm._v(" "),
      _c("form-item", {
        attrs: { label: "Account Number" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function() {
              return [
                _c("Input", {
                  attrs: {
                    placeholder: "Account Number",
                    error:
                      _vm.$v.account_number.$dirty &&
                      !_vm.$v.account_number.required
                  },
                  model: {
                    value: _vm.account_number,
                    callback: function($$v) {
                      _vm.account_number = $$v
                    },
                    expression: "account_number"
                  }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "flex flex-col pt-2" },
                  [
                    _vm.$v.account_number.$dirty &&
                    !_vm.$v.account_number.required
                      ? _c("text-error", {
                          attrs: { text: "Account Number must be filled." }
                        })
                      : _vm._e()
                  ],
                  1
                )
              ]
            },
            proxy: true
          }
        ])
      }),
      _vm._v(" "),
      _c("form-item", {
        attrs: { label: "Swift Code" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function() {
              return [
                _c("Input", {
                  attrs: {
                    placeholder: "Swift Code",
                    error:
                      _vm.$v.swift_code.$dirty && !_vm.$v.swift_code.required
                  },
                  model: {
                    value: _vm.swift_code,
                    callback: function($$v) {
                      _vm.swift_code = $$v
                    },
                    expression: "swift_code"
                  }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "flex flex-col pt-2" },
                  [
                    _vm.$v.swift_code.$dirty && !_vm.$v.swift_code.required
                      ? _c("text-error", {
                          attrs: { text: "Swift Code must be filled." }
                        })
                      : _vm._e()
                  ],
                  1
                )
              ]
            },
            proxy: true
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-67e496df", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-67e496df","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/ArtistContent/Step2.vue
// module id = null
// module chunks = 